import { render, staticRenderFns } from "./MenuTotalCalls.vue?vue&type=template&id=1c1ffbd2&scoped=true"
import script from "./MenuTotalCalls.vue?vue&type=script&lang=js"
export * from "./MenuTotalCalls.vue?vue&type=script&lang=js"
import style0 from "./MenuTotalCalls.vue?vue&type=style&index=0&id=1c1ffbd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1ffbd2",
  null
  
)

export default component.exports